import { BugsnagStatic } from '@bugsnag/js';
import angular, { IWindowService } from 'angular';

type B2BFeatureFlags = 'SSO';

export class BugsnagService {
  static $inject = ['$window'];

  private get instance() {
    return this.$window.Bugsnag as BugsnagStatic;
  }

  notify = this.instance.notify;

  constructor(private $window: IWindowService) {}

  start() {
    if (this.instance && this.$window?.CONFIG?.bugsnag?.key) {
      this.instance.start({
        apiKey: this.$window.CONFIG.bugsnag.key,
        releaseStage: this.$window.CONFIG.environment,
        appVersion: this.$window.VERSION,
      });
    }
  }

  addFeatureFlag(name: B2BFeatureFlags, variant?: string | null) {
    this.instance.addFeatureFlag(name, variant);
  }

  clearFeatureFlag(name: B2BFeatureFlags) {
    this.instance.clearFeatureFlag(name);
  }
}

export const BugsnagServiceModule = angular
  .module('acme.common.service.bugsnag', [])
  .service('BugsnagService', BugsnagService).name;
